import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import ReactTable from 'react-table';
import "react-table/react-table.css";
import Modal from 'react-responsive-modal';
import Pagination from '../../page/Pagination';
import FILING_CONTROLLER from "../../../controllers/filing";
import ENUMS, {ExtrastatFlowEnum} from '../../../utils/enums';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import FilingReportTypeSelector from '../Generic/ReportTypeSelector';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
import {CSVLink} from 'react-csv';
import _ from "lodash";

const log = new Logger('EXTRA_FILING_VALUES', LOG_LEVELS.DEBUG);
const exportFileName = 'ExtrastatDetails.csv'
class ExtrastatFilingValues extends Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, { isLineDetailsPopupOpen: false, loading: false});
    }
    onSelectReportType (event) {
        log.debug('onSelectReportType():', event);
        log.debug('onSelectReportType(): listingType: ', event.target.value);
    
        if(typeof this.props.onReportChangeHandler === 'function') {
          this.setState({ isRequestIdSelected: true });
          this.props.onReportChangeHandler ( {'selectedReportType': event.target.value });
        }
      }
    // To Do in Extrastat Part2 SVR-4238
    //    onClickExtrastLine(e, state, rowInfo, column, instance) {
    //     const lineData = rowInfo.original || {};
    //     const lineDetails = (this.props.filingValues.lines && this.props.filingValues.lines[rowInfo.index]) || {};
    //     this.props.onShowExtrastatDetails(lineDetails.invoices);
    //     this.setState({isLineDetailsPopupOpen: true });
    // }
    onCloseModal(){
        this.setState({ isLineDetailsPopupOpen: false });
    }

    render() {
        log.debug('ExtrastatFilingValues');
        log.debug('render(): ', this.props);
        console.log('Extrastat selectedReportType ',this.props.selectedReportType);
        const Extrastat = this.props.filingValues.lines || [];
        log.debug('render(): lines: ', Extrastat);
        let data = Extrastat;
       
        const cols = [
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_ReportingCountry'), accessor:'ReportingCountry',minWidth :130},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_ReportingDirection'), accessor:'ReportingDirection',minWidth :140},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_SumOfCommercialValue'), accessor:'SumOfCommercialValue',className: "text-align-right",minWidth :170},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_CommodityCode'), accessor:'CommodityCode',minWidth :130},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_ShipFrom'), accessor:'ShipFrom',minWidth :90},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_ShipTo'), accessor:'ShipTo',minWidth :90},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_AdditionalDescription'), accessor:'AdditionalDescription',minWidth :150},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_SumOfQuantity1'), accessor:'SumOfQuantity1',className: "text-align-right",minWidth :140},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_Unit1'), accessor:'Unit1',minWidth :60},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_SumOfQuantity2'), accessor:'SumOfQuantity2',className: "text-align-right",minWidth :140},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_Unit2'), accessor:'Unit2',minWidth :60},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_ModeOfTransport'), accessor:	'ModeOfTransport',minWidth :140},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_CountryOrigin'), accessor:'CountryOrigin',minWidth :120},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_NationalityTransportMeans'), accessor:'NationalityTransportMeans',minWidth :180},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_CountryCustomsDeclaration'), accessor:'CountryCustomsDeclaration',minWidth :190},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_InternalModeOfTransport'), accessor:	'InternalModeOfTransport',minWidth :170},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_EUCountryDispatch'), accessor:'EUCountryDispatch',minWidth :150},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_EUCountryArrival'), accessor:'EUCountryArrival',minWidth :150},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_ExtrastatContainer'), accessor:'ExtrastatContainer',minWidth :150},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_EORINRPSI'), accessor:'EORINRPSI',minWidth :130},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_EORINRPSIAgent'), accessor:'EORINRPSIAgent',minWidth :140},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_CustomsProcedureCode'), accessor:'CustomsProcedureCode',minWidth :170},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_PreferentialTreatment'), accessor:'PreferentialTreatment',minWidth :160},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_StatisticalProcedure'), accessor:'StatisticalProcedure',minWidth :150},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_TransactionType'), accessor:'TransactionType',minWidth :130},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_InvoiceCurrency'), accessor:'InvoiceCurrency',minWidth :130},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_PartnerCountry'), accessor:'PartnerCountry',minWidth :130},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_EUCountry'), accessor:'EUCountry',minWidth :100},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_CompanyCode'), accessor:	'CompanyCode',minWidth :110},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_SumOfCommercialValue2'), accessor:'SumOfCommercialValue2',className: "text-align-right",minWidth :180},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_SumOfStatisticalValue'), accessor:'SumOfStatisticalValue',className: "text-align-right",minWidth :170},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_SumOfStatisticalValue2'), accessor:'SumOfStatisticalValue2',className: "text-align-right",minWidth :170},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_DocumentCurrency'), accessor:'DocumentCurrency',minWidth :150},
                { Header: LANGUAGES_CONTROLLER.format(this.props.languages,	'extra_Invoices'), accessor:'Invoices',minWidth :400},
            ];

        log.debug('render(): ExtrastatData: ', data);
        
        const modalClasses = {
            modal: 'modal-full-width-height modal-max-width-75'
        };
        return (
            <div>
                <s-row>
                    <s-col span="6">  
                        <div className="mb20">
                            <FilingReportTypeSelector flowTypes= {Object.keys(ExtrastatFlowEnum.props).filter((t) => t !== ExtrastatFlowEnum.NONE)} selectValue={this.props.selectedReportType}  
                            onChange={(e) => this.onSelectReportType(e)}></FilingReportTypeSelector>
                        </div>  
                    </s-col>
                </s-row>
                <ReactTable 
                    data={data} 
                    columns={cols}
                    minRows={0}    
                    maxRows={0}   
                    className="-striped -highlight" 
                    noDataText={LANGUAGES_CONTROLLER.format(this.props.languages, 'ecListingFilingValues_NoData')}
                    defaultPageSize={20}
                    pageSizeOptions={[ 20, 50, 100, 1000]}
                    showPagination={data.length !== 0}
                    PaginationComponent={Pagination}
                    sortable={false}
                    // To Do in Extrastat Part2 SVR-4238
                    // getTrProps={(state, rowInfo, column, instance) => {
                    //     return {
                    //         //  onClick: e => {
                    //         //     this.onClickExtrastLine(e, state, rowInfo, column, instance);
                    //         // }
                    //     }
                    // }}
                />
                <br/>
                <CSVLink
                    data={sanitizeCsvData(data)}
                    filename={exportFileName}
                    className={data && data.length > 0 ? "button secondary" : "invisible"}>
                    <LanguageStringResolver string='extrastatFiling_ExportToCSV'/>
                </CSVLink>
                <br/>
                <div>
                    <Modal open={this.state.isLineDetailsPopupOpen} onClose={this.onCloseModal.bind(this)} classNames={modalClasses}>
                        <div style={{padding: '10px'}}>
                            <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'ExtraLine_Header')}</h2>
                                <div>
                                    {/* To Do in Extrastat Part2 SVR-4238 <ExtrastatLineDetails /> */}
                                </div>
                        </div>
                    </Modal>
                </div>
            </div>

        );
    }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        languages: state.languages
    };
}

function mapDispatchersToProps(dispatch) {
    return {
        onShowRxtrastatDetails: (lineNumbers) => {
            log.debug('onShowRxtrastatDetails: ', lineNumbers);
            // To do in Extrastat Part2 SVR-4238
            //dispatch(FILING_CONTROLLER.doLoadExtrastatDetails(lineNumbers));
        }
          };
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(ExtrastatFilingValues);
